module.exports = __webpack_public_path__ + "static/media/10_avatar_male.dfdcea28.png";